import {AfterViewInit, Component, OnInit} from "@angular/core";
import * as AOS from 'aos';
import {DateTime} from 'luxon';


@Component({
    selector: 'app-customer',
    templateUrl: './customer.component.html',
    styleUrls: ['./customer.component.scss']
})

export class CustomerComponent implements AfterViewInit, OnInit {

    selectedIndex: number = 0;

    sections = [
        {
            title: 'Daily discounts and price drops across all categories',
            description: `Enjoy fresh deals every day with price drops on products from every category.`,
            image: 'assets/img/icons/gift.png'
        },
        {
            title: 'Bundle offers and combo packs from multiple stores',
            description: `Save more with value-packed combos and curated bundles from various stores.`,
            image: 'assets/img/icons/flash-sale.png'
        },
        {
            title: 'Seasonal promotions and app-exclusive deals',
            description: `Grab limited-time seasonal discounts and special deals only available on our app.`,
            image: 'assets/img/icons/contract.png'
        },
        {
            title: 'Personalized offers based on your shopping history',
            description: `Get recommendations and discounts tailored to your unique shopping preferences.`,
            image: 'assets/img/icons/offers.png'
        }
    ];

    productUploadLimit = {
        basic: 50,
        standard: 200,
        advanced: 500
    };

    orderTrackingLimit = {
        basic: 50,
        standard: 150,
        advanced: 300
    };

    support = {
        basic: 'Email',
        standard: 'Email + WhatsApp',
        advanced: 'Email + WhatsApp + Phone'
    };

    merchantCommission = '0%';

    nonMerchantCommission = {
        basic: '1%',
        standard: '0.75%',
        advanced: '0.5%'
    };

    costToJoin = '₹0';

    public currentYear: string = DateTime.now().toFormat('y');

    isOpen: boolean = false;
    customerContent: boolean = false;

    get selectedSection() {
        return this.sections[this.selectedIndex];
    }

    selectSection(index: number) {
        this.selectedIndex = index;
    }


    ngAfterViewInit(): void {
        AOS.init({
            duration: 1000,  // Optional: override duration globally
            once: true       // Optional: animate only once
        });
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.isOpen = true;
        }, 2000);
    }

    customerType(type: string) {
        this.customerContent = type === 'Customer';
        this.isOpen = false;
    }
}